import { getAdjustedDirection, getClipPolygonParams } from '../../utils';
export { initialFrame } from './common';
const DIRECTIONS = ['top', 'right', 'bottom', 'left'];
function getClipStart(rotateZ, direction) {
  const clipDirection = getAdjustedDirection(DIRECTIONS, direction, rotateZ);
  return getClipPolygonParams({
    direction: clipDirection,
    minimum: 0
  });
}
export function web(options, dom) {
  prepare(options, dom);
  return style(options);
}
export function style(options) {
  const {
    direction = 'left'
  } = options.namedEffect;
  const easing = options.easing || 'cubicInOut';
  const start = getClipStart(0, direction);
  const end = getClipPolygonParams({
    direction: 'initial'
  });
  const custom = {
    '--motion-clip-start': start
  };
  return [{
    ...options,
    easing,
    name: 'revealIn',
    custom,
    keyframes: [{
      clipPath: `var(--motion-clip-start, ${start})`
    }, {
      clipPath: end
    }]
  }];
}
export function prepare(options, dom) {
  const {
    direction = 'left'
  } = options.namedEffect;
  if (dom) {
    dom.measure(target => {
      if (!target) {
        return;
      }
      const rotation = getComputedStyle(target).getPropertyValue('--comp-rotate-z') || '0deg';
      dom.mutate(target_ => {
        target_ == null || target_.style.setProperty('--motion-clip-start', getClipStart(parseInt(rotation, 10), direction));
      });
    });
  }
}
//# sourceMappingURL=RevealIn.js.map